/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SpecialPricePartialRateRequestDto {
  id: string;
  productId: string;
  specialRate: number;
  relativePriceType: SpecialPricePartialRateRequestDto.RelativePriceTypeEnum;
}
// tslint:disable-next-line:no-namespace
export namespace SpecialPricePartialRateRequestDto {
  export type RelativePriceTypeEnum = 'relative_amount' | 'relative_percentage';
  export const RelativePriceTypeEnum = {
      Amount: 'relative_amount' as RelativePriceTypeEnum,
      Percentage: 'relative_percentage' as RelativePriceTypeEnum,
  };
}
